import { render, staticRenderFns } from "./product-add-modal.component.vue?vue&type=template&id=28ed858c&"
import script from "./product-add-modal.component.vue?vue&type=script&lang=ts&"
export * from "./product-add-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./product-add-modal.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "product-add-modal.component.vue"
export default component.exports